import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Main from "./Main";
import Modules from "./Modules";
import VowelSubmodules from "./VowelSubmodules";
import StressSubmodules from "./StressSubmodules";
import SubmoduleDropdown from "./SubmoduleDropdown";
import About from "./About";
import Layout from "./Layout";
import Tutorial from "./Tutorial";

export default function App() {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/modules" element={<Modules />} />
                <Route path="/main" element={<Main />} />
                <Route path="/VowelSubmodules" element={<VowelSubmodules />} />
                <Route path="/Tutorial" element={<Tutorial />} />
                <Route
                    path="/StressSubmodules"
                    element={<StressSubmodules />}
                />
                <Route
                    path="/SubmoduleDropdown"
                    element={<SubmoduleDropdown />}
                />
            </Route>
            {/* About routes are outside Layout so the page doesn't link to itself */}
            <Route path="/About" element={<About />} />
            <Route path="/about" element={<About />} />
        </Routes>
    );
}
